import { render, staticRenderFns } from "./u-table-line.vue?vue&type=template&id=04b1b5b4&scoped=true"
import script from "./u-table-line.vue?vue&type=script&lang=js"
export * from "./u-table-line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b1b5b4",
  null
  
)

export default component.exports